import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => (
    <h1>
        Dates Wall
    </h1>
)

export default Header


// WEBPACK FOOTER //
// ./resources/js/components/Header.js